import { ShimmerMetricRow, ShimmerTwoCol } from "./DashboardShimmer";
import AverageWeights from "./AverageWeights";
import LossMetrics from "./LossMetrics";
import "./dashboard-sections.css";

const DUMMY = {
  total_paid_cases:  12450,
  total_paid_kg:     249000,
  total_orange_kg:   184200,
  total_ripened_kg:  58600,
  total_rejected_kg: 4120,
};

const FreshFruitRunningTotals = ({ data = DUMMY, isLoading = false }) => {
  const metrics = [
    { label: "Total Paid Cases",  value: data.total_paid_cases?.toLocaleString(),  unit: "",   badge: "+4%" },
    { label: "Total Paid KG",     value: data.total_paid_kg?.toLocaleString(),     unit: "kg"  },
    { label: "Total Orange KG",   value: data.total_orange_kg?.toLocaleString(),   unit: "kg"  },
    { label: "Total Ripened KG",  value: data.total_ripened_kg?.toLocaleString(),  unit: "kg"  },
    { label: "Total Rejected KG", value: data.total_rejected_kg?.toLocaleString(), unit: "",   danger: true, dot: true },
  ];

  return (
    <div className="db-section">
      {/* Section header */}
      <div className="db-section-title">
        <span className="db-title-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
            <polyline points="9 22 9 12 15 12 15 22"/>
          </svg>
        </span>
        Fresh Fruit Running Totals
      </div>

      {/* Metric cards */}
      {isLoading ? (
        <ShimmerMetricRow count={5} />
      ) : (
        <div className="db-metric-row">
          {metrics.map((m, i) => (
            <div key={i} className="db-metric-card">
              <div className="db-metric-label">{m.label}</div>
              <div className={`db-metric-value${m.danger ? " danger" : ""}`}>
                {m.value}
                {m.unit && <span className="db-metric-unit">{m.unit}</span>}
                {m.badge && <span className="db-metric-badge">{m.badge}</span>}
                {m.dot && <span className="db-metric-dot" />}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Sub-sections inside Fresh Fruit Running Totals */}
      <div className="db-subsections">
        <AverageWeights isLoading={isLoading} />
        <LossMetrics isLoading={isLoading} />
      </div>
    </div>
  );
};

export default FreshFruitRunningTotals;
